import hhrms from "../assets/hhrms-pic.png";
import lms from "../assets/lmsapp.png";
import todoapp from "../assets/todoapp.png";

export const softwaresDummyData = [
  {
    id: 1,
    image: hhrms,
    name: "Hospital HR Management System",
    price: "50,000",
    desc: "Web Application"
  },
  {
    id: 2,
    image: lms,
    name: "Library Management System (LMS)",
    price: "50,000",
    desc: "Desktop Application"
  },
  {
    id: 3,
    image: todoapp,
    name: "To Do List",
    price: "50,000",
    desc: "Mobile & Web Application"
  }
];
